import { PcApiResponse } from '@/api/pc-api/types';
import { SettleUnitType } from '@/constants/settle';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export const getSettleUnitType = (partnerId: string) => {
  return api<PcApiResponse<SettleUnitType>>('get', `/pc-api/v1/${PREFIX_PATH}/partner/${partnerId}/settle-unit-type`);
};
